<template>
  <div>
    <global-table
      :table-data="customerDocument"
      :loading="loading"
      :per-page="10"
      :table-detail="tableDetail"
      :bordered="true"
      :hover="true"
      :striped="false"
      :id-modals="'customerDocumentForm'"
      :redirect-detail="false"
      :edit-button="false"
      :show-add-button="childAddButton"
      :remove-button="childAddButton"
      :fields="fieldsCustomerDocument"
      addButton="Dokumen"
      @resetForm="resetCustomerDocument"
      @removeForm="removeCustomerDocument"
      @goToPreviewImage="showPreviewImage"
    ></global-table>

    <b-modal
      ref="customerDocumentForm"
      id="customerDocumentForm"
      header-border-variant="no-border text-center"
      footer-border-variant="no-border"
      footer-bg-variant="light"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      hide-footer
      size="lg"
    >
      <div slot="modal-header" class="text-center">
        <h3 class="text-center">Dokumen</h3>
      </div>

      <div v-if="!loadingSubmit">
        <b-form
          id="customerDocumentForm"
          validated
          novalidate
          @submit="saveCustomerDocument"
        >
          <b-row>
            <b-col sm="3">
              <b-form-group label-for="name" label="Nama">
                <b-form-input
                  id="name"
                  type="text"
                  v-model="$v.customerDocumentForm.name.$model"
                  :state="!$v.customerDocumentForm.name.$invalid"
                  placeholder="Nama"
                  required
                ></b-form-input>
                <b-form-invalid-feedback
                  >Nama harus di isi.</b-form-invalid-feedback
                >
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col sm="4">
              <b-form-group label-for="file" label="Dokumen">
                <b-form-file
                  ref="inputDocument"
                  accept="image/*"
                  @change="OnFileSelected($event)"
                  v-model="customerDocumentForm.file"
                  required
                ></b-form-file>
                <div
                  v-if="
                    customerDocumentForm.file === null ||
                    customerDocumentForm.file === undefined
                  "
                  class="invalid-feedback-custom"
                >
                  Dokumen harus di isi.
                </div>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col sm="3">
              <b-form-group label-for="document_type" label="Tipe Dokumen">
                <model-select
                  id="document_type"
                  :options="listDocument"
                  v-model="$v.customerDocumentForm.document_type.$model"
                  :isError="$v.customerDocumentForm.document_type.$invalid"
                  placeholder="-- Harap pilih salah satu --"
                ></model-select>
                <div
                  v-if="customerDocumentForm.document_type === null"
                  class="invalid-feedback-custom"
                >
                  Tipe dokumen harus di isi.
                </div>
              </b-form-group>
            </b-col>
          </b-row>

          <div class="float-right">
            <b-button
              type="button"
              size="sm"
              variant="danger"
              @click="cancelCustomerDocument"
            >
              <i class="fa fa-undo"></i> Back </b-button
            >&nbsp;
            <b-button
              type="submit"
              size="sm"
              variant="primary"
              :disabled="$v.customerDocumentForm.$invalid"
            >
              <i class="fa fa-save"></i> Save
            </b-button>
          </div>
        </b-form>
      </div>

      <div v-else>
        <loading></loading>
      </div>
    </b-modal>

    <b-modal
      ref="openPreviewImage"
      id="openPreviewImage"
      header-border-variant="no-border text-center"
      footer-border-variant="no-border"
      footer-bg-variant="light"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      hide-footer
      size="lg"
    >
      <div slot="modal-header" class="text-center">
        <h3 class="text-center">Preview Dokumen</h3>
      </div>
      <b-row>
        <b-col sm="12">
          <template v-if="verificationAssets !== ''">
            <b-img
              :src="verificationAssets"
              fluid
            ></b-img>
          </template>
          <template v-else>
            <b-img
              v-if="previewImage !== null && ['jpg', 'jpeg', 'png','gif'].includes(extentions)"
              :src="imgpath + 'customer/document/' + previewImage"
              fluid
            ></b-img>
            <embed v-else type="application/pdf" :src="imgpath + 'customer/document/' + previewImage" width="100%" height="700">
          </template>
        </b-col>
        <br />
      </b-row>

      <div class="float-right">
        <b-button
          type="button"
          size="sm"
          variant="danger"
          @click="closePreview"
        >
          <i class="fa fa-undo"></i> Back
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import globalTable from "@/templates/Table.vue";
import interfaces from "@/templates/_interfaces.js";
import _accessApi from "@/router/_accessApi.js";
import { required, email } from "vuelidate/lib/validators";
import "moment/locale/id";
import { ModelSelect, MultiSelect } from "vue-search-select";
import loading from "@/templates/Loading.vue";

export default {
  name: "document-customer",
  components: { globalTable, ModelSelect, MultiSelect, loading },
  props: {
    tableDetail: {
      type: Boolean,
      default: true,
    },
    customer: {
      type: [Array, Object],
      default: () => {},
    },
    customerDocument: {
      type: [Array],
      default: () => [],
    },
    listDocument: {
      type: [Array],
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: true,
    },
    childAddButton: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      urlAssets: "https://storage.googleapis.com/mbsstorage/",
      verificationAssets: '',
      myCustomer: {},
      previewImage: null,
      loadingSubmit: false,
      extentions:null,
      imgpath:
        location.host === "localhost:8080"
          ? _accessApi.server.upload_path
          : _accessApi.server.upload_path,
      fieldsCustomerDocument: [
        { key: "document_name_preview", label: "Nama" },
        { key: "document_type", label: "Tipe Dokumen" },
        { key: "action", label: "Action", class: "text-center width-80" },
      ],
      customerDocumentForm: interfaces.customer_document,
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  validations: {
    customerDocumentForm: {
      file: { required },
      name: { required },
      document_type: { required },
    },
  },
  methods: {
    init: function () {},
    reload(cust_id) {
      this.$emit("reload", cust_id);
    },
    cancelCustomerDocument: function () {
      this.resetCustomerDocument();
      this.$refs.customerDocumentForm.hide();
      //this.$refs["inputDocument"].reset();
    },
    saveCustomerDocument: function (evt) {
      evt.preventDefault();
      if (confirm("Apakah anda ingin mengubah dokumen konsumen ini ?")) {
        this.loadingSubmit = true;
        let formData = new FormData();
        formData.append("customer_id", this.customer.id);
        formData.append("name", this.customerDocumentForm.name);
        formData.append(
          "document_type",
          this.customerDocumentForm.document_type
        );
        formData.append("file", this.customerDocumentForm.file);
        this.axios
          .post("web/customer/add_attachment/", formData, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then((response) => {
            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: "Ubah dokumen konsumen",
                message: response.data.message,
              });
            }
          })
          .catch((error) => {
            this.expired(error, "Ubah dokumen konsumen");
          })
          .finally(() => {
            this.loadingSubmit = false;
            this.cancelCustomerDocument();
            this.reload(this.customer.id);
          });
      }
    },
    showPreviewImage: function (data) {
        this.$refs.openPreviewImage.show();
      if(data.doctype_id === '12') {
        this.verificationAssets = this.urlAssets+data.data;
      } else {
        let temp = data.data.split('.');
        this.extentions = temp[1].toLowerCase().trim();
        this.previewImage = data.data;
        this.verificationAssets = '';
      }
      console.log(this.verificationAssets)
    },
    closePreview: function () {
      this.$refs.openPreviewImage.hide();
    },
    removeCustomerDocument: function (data) {
      if(data.document_type_id !== '12') {
        if (confirm("Apakah anda ingin menghapus dokumen konsumen ini ?")) {
          this.axios
            .delete("web/customer/remove_attachment/" + data.id)
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: "Hapus dokumen konsumen",
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.expired(error, "Hapus dokumen konsumen");
            })
            .finally(() => {
              this.reload(this.customer.id);
            });
        }
      } else {
        alert('Data verifikasi mobile tidak boleh di hapus');
      }
    },
    OnFileSelected: function (event) {
      this.customerDocumentForm.file = event.target.files[0];
    },
    resetCustomerDocument: function () {
      for (var a in interfaces.customer_document) {
        interfaces.customer_document[a] = null;
      }
      this.customerDocumentForm = interfaces.customer_document;
    },
    expired: function (error, title) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired",
        });
      } else {
        this.showErrorNotification({
          title: title,
          message: error.response.data.message,
        });
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style>
</style>
